export default {
    LOAD_SALES_HISTORIC(state, sales_historic) {
        state.items = sales_historic;
    }
}